<template>
  <div class="right_info">
    <component :is="component_name"></component>
  </div>
</template>

<script>
// import all components dynamically for inclusion on the right info tab depending on the component name property
let Components = {};
let context = require.context('./right_info', true, /\.vue$/);
context.keys().forEach(function (key) {
  let componentName2 = key.match(/\/([^\/]+?)\.vue$/)[1];
  Components[componentName2] = context(key).default
});

export default {
  name: "right_info",
  components: Components,
  data() {
    return {
      component_name: this.$store.state.right_info.type
    }
  }
}
</script>

<style lang="scss">
.right_info {
  overflow-y:         auto;
  background-color:   $right_info_bg;
  position:           fixed;
  right:              0;
  top:                $tm_height;
  height:             calc(100vh - 43px);
  z-index:            99;
  /*padding:            10px;*/
  width:              $right_info_width;
  -webkit-box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.6);
  -moz-box-shadow:    0 3px 6px 0 rgba(0, 0, 0, 0.6);
  box-shadow:         0 3px 6px 0 rgba(0, 0, 0, 0.6);

  #right_info_close {
    width:       85px;
    padding:     0;
    font-size:   0.65rem;
    line-height: 30px;
    float:       right;
  }
}
</style>
